export default "__VITE_ASSET__74d05b90__"